import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal, Select, Button } from 'antd';
import styled from 'styled-components';

const { Option } = Select;

const StyledModal = styled(Modal)`
	.ant-modal-title {
		font-size: 20px;
		font-weight: 700;
		color: #1e293b;
	}

	.ant-modal-body {
		padding: 24px;
	}

	.ant-select-selector {
		height: 40px !important;
		border-radius: 6px !important;
		display: flex;
		align-items: center;
	}
`;

const FieldLabel = styled.div`
	font-size: 15px;
	color: #1f2937;
	margin-bottom: 8px;
`;

const Helper = styled.div`
	margin-top: 8px;
	color: #6b7280;
	font-size: 13px;
`;

const Footer = styled.div`
	display: flex;
	justify-content: flex-end;
	gap: 12px;
	margin-top: 28px;
	border-top: 1px solid #e5e7eb;
	padding-top: 16px;
`;

const SaveButton = styled(Button)`
	height: 40px;
	padding: 0 32px;
	background-color: #1e3a5f;
	border-color: #1e3a5f;
	color: #fff;
	border-radius: 6px;

	&:hover,
	&:focus {
		background-color: #18405d !important;
		border-color: #18405d !important;
		color: #fff !important;
	}
`;

function AssignSacCodeModal({ visible, options, initialValue, onSave, onClose }) {
	const [sacCode, setSacCode] = useState(initialValue);

	useEffect(() => {
		if (visible) setSacCode(initialValue || undefined);
	}, [visible, initialValue]);

	const selected = options.find((o) => o.value === sacCode);

	const handleSave = () => {
		if (!sacCode) return;
		onSave({ sac_code: sacCode, tax_rate: selected?.rate });
	};

	return (
		<StyledModal
			title="Assign SAC Code"
			open={visible}
			onCancel={onClose}
			footer={null}
			width={620}
		>
			<FieldLabel>SAC Code</FieldLabel>
			<Select
				style={{ width: '100%' }}
				placeholder="Select SAC Code"
				value={sacCode}
				onChange={setSacCode}
				showSearch
				optionFilterProp="children"
			>
				{options.map((o) => (
					<Option key={o.value} value={o.value}>
						{o.label}
					</Option>
				))}
			</Select>
			{selected ? <Helper>Tax rate auto-derived: {selected.rate}%</Helper> : null}

			<Footer>
				<Button
					style={{ height: 40, padding: '0 24px', borderRadius: 6 }}
					onClick={onClose}
				>
					Cancel
				</Button>
				<SaveButton onClick={handleSave} disabled={!sacCode}>
					Save
				</SaveButton>
			</Footer>
		</StyledModal>
	);
}

AssignSacCodeModal.propTypes = {
	visible: PropTypes.bool.isRequired,
	options: PropTypes.arrayOf(PropTypes.object),
	initialValue: PropTypes.string,
	onSave: PropTypes.func.isRequired,
	onClose: PropTypes.func.isRequired,
};

AssignSacCodeModal.defaultProps = {
	options: [],
	initialValue: undefined,
};

export default AssignSacCodeModal;
